import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { undoableCombatConfigurationDeleteEnemyCombatPreset } from '../../stores/undo/operation/CombatConfigurationSubmitChangesOp';
import { EnemyCombatPresetEditorRound } from './EnemyCombatPresetEditorRound';
import { gameStore } from '../../stores/GameStore';
const AddRoundContainer = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditor__AddRoundContainer",
  componentId: "sc-106hhu6-0"
})(["margin:1em 0;"]);
const AddRoundContainerButton = styled.button.withConfig({
  displayName: "EnemyCombatPresetEditor__AddRoundContainerButton",
  componentId: "sc-106hhu6-1"
})(["width:100%;"]);
const DeleteButtonContainer = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditor__DeleteButtonContainer",
  componentId: "sc-106hhu6-2"
})(["display:flex;justify-content:flex-end;button{color:red;}"]);
export const EnemyCombatPresetEditor = observer(({
  enemyCombatPreset
}) => {
  const {
    t
  } = useTranslation();
  const {
    languageKey
  } = gameStore;
  return /*#__PURE__*/React.createElement("div", {
    key: enemyCombatPreset.$modelId
  }, /*#__PURE__*/React.createElement("div", null, t("editor.translated_name"), ":\xA0", /*#__PURE__*/React.createElement("input", {
    value: enemyCombatPreset.name.get(languageKey, false),
    placeholder: enemyCombatPreset.name.get(languageKey, true),
    onChange: e => enemyCombatPreset.name.set(languageKey, e.target.value)
  })), enemyCombatPreset.rounds.map((round, index) => /*#__PURE__*/React.createElement(EnemyCombatPresetEditorRound, {
    key: round.$modelId,
    round: round,
    enemyCombatPreset: enemyCombatPreset,
    roundIndex: index
  })), /*#__PURE__*/React.createElement(AddRoundContainer, null, /*#__PURE__*/React.createElement(AddRoundContainerButton, {
    onClick: () => enemyCombatPreset.addRound()
  }, t("editor.combat_enemy_combat_preset_add_round"))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(DeleteButtonContainer, null, /*#__PURE__*/React.createElement("button", {
    onClick: () => undoableCombatConfigurationDeleteEnemyCombatPreset(enemyCombatPreset)
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMinusCircle
  }), " ", t("editor.combat_enemy_combat_preset_delete"))));
});